import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ConfirmationModal } from './ConfirmationModal';
import { axios } from '../api';
import { TrashIcon } from '../assets/TrashIcon';
import { isAdmin, isAllModuleAccessUser } from '../pages/constants';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

interface DeletePIIProps {
  email: string;
  is_lead?: boolean;
  id?: string;
}

export const DeletePII = ({ email, is_lead = false, id }: DeletePIIProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const canDeletePII = isAdmin() || isAllModuleAccessUser();
  const entityLabel = is_lead ? 'lead' : 'customer';
  const reloadTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (reloadTimerRef.current) clearTimeout(reloadTimerRef.current);
    };
  }, []);

  const handleDeletePII = () => {
    axios
      .post(is_lead ? `delete_lead_pii` : `delete_pii`, is_lead ? { id } : { email })
      .then(() => {
        toast.success(
          `Success! The PII for ${entityLabel} ${email} has been deleted.`,
          BOTTOM_TOAST
        );
        reloadTimerRef.current = setTimeout(() => window.location.reload(), 1000);
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      });
    setShowConfirmModal(false);
  };
  if (email && canDeletePII) {
    return (
      <div className="flex justify-between items-center">
        <TrashIcon
          className="inline w-4 h-4 mx-1 cursor-pointer"
          onClick={() => setShowConfirmModal(true)}
        />
        {showConfirmModal && (
          <ConfirmationModal
            title={`Are you sure you want to delete this ${entityLabel}'s PII?`}
            customMessage={
              <p className="text-sm mb-4 text-center text-red-600">
                By proceeding, you will remove all personally identifiable information from our
                database for this {entityLabel}. This action is irreversible.
              </p>
            }
            confirmLabel="Confirm"
            onConfirm={handleDeletePII}
            onCancel={() => setShowConfirmModal(false)}
          />
        )}
      </div>
    );
  }
};
